import { useAccount } from '@/hooks/useAccount';
import React from 'react';
import { useHistory } from 'react-router-dom';

/**
 * 認証必須のラッパーコンポーネントです。
 * 
 */
export const MustBeAuth: React.FC = ({children}) => {
    const history = useHistory();
 
    const { isLoggedIn } = useAccount();

    if (!isLoggedIn) {
        const qs = `?path=${encodeURIComponent(history.location.pathname)}`
        history.push('/auth/signin' + qs);
        return null;            
    }

    return <>{children}</>
}

/**
 * 認証されていない必須のラッパーコンポーネントです。
 */
 export const MustNotBeAuth: React.FC = ({children}) => {
    const history = useHistory();
 
    const { isLoggedIn } = useAccount();

    if (isLoggedIn) {
        if (history.location.pathname != '/dashboard') {
            history.push('/dashboard');
            return null;
        }
    }

    return <>{children}</>
}

